import React from "react";
import ReactDOM from "react-dom";
import { CourseDetail } from "../components/CourseDetail";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderCourseDetail = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<CourseDetail props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering CourseDetail:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
